// =====================================================================
// PAWLY ADDON ENGINE (dog-name / phone-number / leash-style / AirTag)
// =====================================================================
// (function() {
//   if (window.__pawlyAddonScriptInitialized) {
//     return;
//   }
//   window.__pawlyAddonScriptInitialized = true;
//   // ===============================================================
//   // CONFIG
//   // ===============================================================
//   const FORM_SELECTOR = '.custom-product-wrapper form[data-type="add-to-cart-form"]';
//   // -----------------------------------------------------------------
//   // Per-page variant configuration.
//   // -----------------------------------------------------------------
//   function getAddonConfig() {
//     const DEFAULTS = {
//       dogNameDefault: '51599621488921',
//       dogNameXS: '52066760196377',
//       phone: '51753591963929',
//       leashRegular: '51563652186393',
//       leashBungee: '52753849549081',
//       airTag: '51972940202265'
//     };
//     const configEl = document.getElementById('pawly-addon-config');
//     if (!configEl) {
//       return DEFAULTS;
//     }
//     try {
//       const parsed = JSON.parse(configEl.textContent);
//       return Object.assign({}, DEFAULTS, parsed || {});
//     } catch (error) {
//       return DEFAULTS;
//     }
//   }
//   const VARIANTS = getAddonConfig();
//   // ===============================================================
//   // TRACKED VALUES
//   // ===============================================================
//   const trackedValues = {
//     dogname: '',
//     phone: '',
//     leashstyle: 'Regular'
//   };
//   // ===============================================================
//   // CURRENT FORM
//   // ===============================================================
//   let activeForm = null;

//   function getForm(preferredForm = null) {
//     if (preferredForm && preferredForm.matches && preferredForm.matches(FORM_SELECTOR)) {
//       activeForm = preferredForm;
//       return preferredForm;
//     }
//     if (activeForm && document.contains(activeForm) && activeForm.matches(FORM_SELECTOR)) {
//       return activeForm;
//     }
//     const form = document.querySelector(FORM_SELECTOR);
//     if (form) {
//       activeForm = form;
//     }
//     return form;
//   }
//   // ===============================================================
//   // GENERATE RELATION ID
//   // ===============================================================
//   function generateAddonGroupId() {
//     return ('addon_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10));
//   }
//   // ===============================================================
//   // SYNC CHILD RELATION IDS WITH MAIN RELATION ID
//   // ===============================================================
//   function syncChildGroupIds(form, mainGroupId) {
//     if (!form || !mainGroupId) {
//       return;
//     }
//     const childGroupInputs = form.querySelectorAll('input[name^="items["][name$="[properties][_addon_group_id]"]');
//     childGroupInputs.forEach(input => {
//       input.value = mainGroupId;
//     });
//   }
//   // ===============================================================
//   // ENSURE MAIN GROUP ID
//   // ===============================================================
//   function ensureAddonGroupId(reason, preferredForm = null) {
//     const form = getForm(preferredForm);
//     if (!form) {
//       return null;
//     }
//     let mainGroupInput = form.querySelector('input[name="properties[_addon_group_id]"]');
//     // -------------------------------------------------------------
//     // 1. EXISTING MAIN RELATION ID
//     // -------------------------------------------------------------
//     if (mainGroupInput && mainGroupInput.value && mainGroupInput.value.trim()) {
//       const groupId = mainGroupInput.value.trim();
//       syncChildGroupIds(form, groupId);
//       return groupId;
//     }
//     // -------------------------------------------------------------
//     // 2. RESTORE FROM CHILD
//     // -------------------------------------------------------------
//     const childGroupInputs = form.querySelectorAll('input[name^="items["][name$="[properties][_addon_group_id]"]');
//     let childGroupId = null;
//     childGroupInputs.forEach(input => {
//       if (!childGroupId && input.value && input.value.trim()) {
//         childGroupId = input.value.trim();
//       }
//     });
//     if (childGroupId) {
//       mainGroupInput = document.createElement('input');
//       mainGroupInput.type = 'hidden';
//       mainGroupInput.name = 'properties[_addon_group_id]';
//       mainGroupInput.value = childGroupId;
//       mainGroupInput.className = 'js-addon-group-id';
//       form.appendChild(mainGroupInput);
//       syncChildGroupIds(form, childGroupId);
//       return childGroupId;
//     }
//     // -------------------------------------------------------------
//     // 3. CREATE NEW RELATION ID
//     // -------------------------------------------------------------
//     const newGroupId = generateAddonGroupId();
//     mainGroupInput = document.createElement('input');
//     mainGroupInput.type = 'hidden';
//     mainGroupInput.name = 'properties[_addon_group_id]';
//     mainGroupInput.value = newGroupId;
//     mainGroupInput.className = 'js-addon-group-id';
//     form.appendChild(mainGroupInput);
//     return newGroupId;
//   }
//   // ===============================================================
//   // MAIN PRODUCT PROPERTY  —  see ROOT CAUSE FIX note at top of file
//   // ===============================================================
//   function setMainProductProperty(propertyName, value, reason, preferredForm = null) {
//     const form = getForm(preferredForm);
//     if (!form) {
//       return false;
//     }
//     if (value === undefined || value === null || String(value).trim() === '') {
//       return false;
//     }
//     const stringValue = String(value).trim();
//     const selector = `input[name="properties[${propertyName}]"]`;
//     // ---------------------------------------------------------------
//     // Look up the property input across the WHOLE document, not just
//     // inside the form. GemPages associates these inputs to the form
//     // via the `form="..."` HTML attribute rather than DOM nesting, so a
//     // form-scoped query can never find them (see file header).
//     // ---------------------------------------------------------------
//     let input = document.querySelector(selector);
//     const allMatches = document.querySelectorAll(selector);
//     if (allMatches.length > 1) {
//       // Prefer whichever input is actually wired to THIS form.
//       const wired = Array.from(allMatches).find(el => form.contains(el) || el.getAttribute('form') === form.id);
//       if (wired) {
//         input = wired;
//         // Clean up any duplicate we may have created before this input
//         // was found, so the payload never carries two values for the
//         // same property name.
//         allMatches.forEach(el => {
//           if (el !== wired && el.classList.contains('js-main-product-property')) {
//             el.remove();
//           }
//         });
//       }
//     }
//     if (!input) {
//       // Last resort: no such field exists anywhere on the page yet.
//       input = document.createElement('input');
//       input.type = 'hidden';
//       input.name = `properties[${propertyName}]`;
//       input.className = 'js-main-product-property';
//       form.appendChild(input);
//     }
//     input.value = stringValue;
//     return input.value === stringValue;
//   }
//   // ===============================================================
//   // REMOVE ADDON ITEM
//   // ===============================================================
//   function removeItemGroup(form, key) {
//     if (!form) {
//       return;
//     }
//     const existing = form.querySelectorAll(`.js-prop-${key}`);
//     existing.forEach(el => el.remove());
//     // IMPORTANT:
//     // Main _addon_group_id is NEVER removed.
//   }
//   // ===============================================================
//   // CREATE HIDDEN INPUT
//   // ===============================================================
//   function createHidden(name, value, key) {
//     const input = document.createElement('input');
//     input.type = 'hidden';
//     input.name = name;
//     input.value = value ?? '';
//     input.classList.add(`js-prop-${key}`);
//     return input;
//   }
//   // ===============================================================
//   // NEXT ITEM INDEX
//   // ===============================================================
//   function getNextItemIndex(form) {
//     const itemInputs = form.querySelectorAll('input[name^="items["][name$="[id]"]');
//     let maxIndex = -1;
//     itemInputs.forEach(input => {
//       const match = input.name.match(/items\[(\d+)\]\[id\]/);
//       if (match) {
//         const index = parseInt(match[1], 10);
//         if (index > maxIndex) {
//           maxIndex = index;
//         }
//       }
//     });
//     return maxIndex + 1;
//   }
//   // ===============================================================
//   // ADD / UPDATE CHILD ADDON
//   // ===============================================================
//   function upsertAddonItem({
//     key,
//     variantId,
//     quantity = 1,
//     properties = {},
//     preferredForm = null
//   }) {
//     const form = getForm(preferredForm);
//     if (!form) {
//       return false;
//     }
//     removeItemGroup(form, key);
//     if (!variantId) {
//       return false;
//     }
//     const groupId = ensureAddonGroupId(`child addon "${key}"`, form);
//     if (!groupId) {
//       return false;
//     }
//     const index = getNextItemIndex(form);
//     form.appendChild(createHidden(`items[${index}][id]`, variantId, key));
//     form.appendChild(createHidden(`items[${index}][quantity]`, quantity, key));
//     form.appendChild(createHidden(`items[${index}][properties][_addon_group_id]`, groupId, key));
//     form.appendChild(createHidden(`items[${index}][properties][_addon_type]`, key, key));
//     Object.entries(properties).forEach(([propKey, propValue]) => {
//       form.appendChild(createHidden(`items[${index}][properties][${propKey}]`, propValue, key));
//     });
//     return true;
//   }
//   // ===============================================================
//   // DOG NAME VARIANT
//   // ===============================================================
//   function getDogNameVariant() {
//     const selectedSize = document.querySelector('[variant-option-name="Size"] label.option-item-active input');
//     if (selectedSize && selectedSize.value.includes('XS (9-14 lb)')) {
//       return VARIANTS.dogNameXS;
//     }
//     return VARIANTS.dogNameDefault;
//   }
//   // ===============================================================
//   // DOG NAME
//   // ===============================================================
//   function processDogName(input, preferredForm = null) {
//     if (!input) {
//       return;
//     }
//     let value = input.value || '';
//     value = value.replace(/[^a-zA-Z\s\-']/g, '');
//     input.value = value;
//     const trimmedValue = value.trim();
//     trackedValues.dogname = trimmedValue;
//     const form = getForm(preferredForm);
//     if (!form) {
//       return;
//     }
//     if (!trimmedValue) {
//       removeItemGroup(form, 'dogname');
//       return;
//     }
//     setMainProductProperty('dog-name', trimmedValue, 'dog name input', form);
//     upsertAddonItem({
//       key: 'dogname',
//       variantId: getDogNameVariant(),
//       quantity: 1,
//       properties: {
//         'Dog Name': trimmedValue
//       },
//       preferredForm: form
//     });
//   }
//   // ===============================================================
//   // PHONE
//   // ===============================================================
//   function processPhone(input, preferredForm = null) {
//     if (!input) {
//       return;
//     }
//     let value = input.value || '';
//     value = value.replace(/[^0-9+]/g, '');
//     input.value = value;
//     const trimmedValue = value.trim();
//     trackedValues.phone = trimmedValue;
//     const form = getForm(preferredForm);
//     if (!form) {
//       return;
//     }
//     if (!trimmedValue) {
//       removeItemGroup(form, 'phone');
//       return;
//     }
//     setMainProductProperty('phone-number', trimmedValue, 'phone input', form);
//     upsertAddonItem({
//       key: 'phone',
//       variantId: VARIANTS.phone,
//       quantity: 1,
//       properties: {
//         'Phone Number': trimmedValue
//       },
//       preferredForm: form
//     });
//   }
//   // ===============================================================
//   // LEASH STYLE
//   // ===============================================================
//   function processLeashStyle(radio, preferredForm = null) {
//     if (!radio || !radio.checked) {
//       return false;
//     }
//     const selectedValue = radio.value.trim();
//     if (!selectedValue) {
//       return false;
//     }
//     trackedValues.leashstyle = selectedValue;
//     const form = getForm(preferredForm);
//     if (!form) {
//       return false;
//     }
//     // -------------------------------------------------------------
//     // MAIN PRODUCT PROPERTY
//     // -------------------------------------------------------------
//     const mainPropertyAdded = setMainProductProperty('leash-style', selectedValue, 'leash style change', form);
//     let variantId = null;
//     if (selectedValue === 'Regular') {
//       variantId = VARIANTS.leashRegular;
//     }
//     if (selectedValue === 'Bungee') {
//       variantId = VARIANTS.leashBungee;
//     }
//     if (!variantId) {
//       removeItemGroup(form, 'leashstyle');
//       return false;
//     }
//     // -------------------------------------------------------------
//     // CHILD LEASH
//     // -------------------------------------------------------------
//     const childAdded = upsertAddonItem({
//       key: 'leashstyle',
//       variantId,
//       quantity: 1,
//       preferredForm: form
//     });
//     return mainPropertyAdded && childAdded;
//   }
//   // ===============================================================
//   // LEASH INITIALIZATION
//   // ===============================================================
//   let leashInitializationTimer = null;

//   function setDefaultLeashStyle(preferredForm = null) {
//     const form = getForm(preferredForm);
//     if (!form) {
//       return false;
//     }
//     // ---------------------------------------------------------------
//     // FIRST: CHECK CURRENTLY SELECTED LEASH
//     // ---------------------------------------------------------------
//     const checked = document.querySelector('.addon-items-wrapper input[name="properties[leash-style]"]:checked');
//     if (checked) {
//       trackedValues.leashstyle = checked.value.trim();
//       return processLeashStyle(checked, form);
//     }
//     // ---------------------------------------------------------------
//     // SECOND: FIND REGULAR LEASH
//     // ---------------------------------------------------------------
//     const regular = document.querySelector('.addon-items-wrapper input[name="properties[leash-style]"][value="Regular"]');
//     if (!regular) {
//       return false;
//     }
//     regular.checked = true;
//     trackedValues.leashstyle = 'Regular';
//     return processLeashStyle(regular, form);
//   }

//   function ensureLeashInitialized(preferredForm = null) {
//     const form = getForm(preferredForm);
//     if (!form) {
//       return;
//     }
//     if (leashInitializationTimer) {
//       clearInterval(leashInitializationTimer);
//       leashInitializationTimer = null;
//     }
//     let attempts = 0;
//     const maxAttempts = 40;
//     const tryInitialize = () => {
//       attempts++;
//       const success = setDefaultLeashStyle(form);
//       if (success || attempts >= maxAttempts) {
//         clearInterval(leashInitializationTimer);
//         leashInitializationTimer = null;
//       }
//     };
//     // Try immediately.
//     tryInitialize();
//     // Retry because GemPages can render this widget asynchronously.
//     // NOTE: this is a UX nicety only — the actual add-to-cart guarantee
//     // does not depend on this retry completing (see
//     // installCartAddNetworkGuarantee below), so a slow/failed retry can
//     // no longer cause a missing property.
//     if (attempts < maxAttempts) {
//       leashInitializationTimer = setInterval(tryInitialize, 100);
//     }
//   }
//   // ===============================================================
//   // AIRTAG
//   // ===============================================================
//   function handleAirTagChange(checkbox, preferredForm = null) {
//     const form = getForm(preferredForm);
//     if (!form) {
//       return;
//     }
//     if (checkbox.checked) {
//       upsertAddonItem({
//         key: 'airtapouch',
//         variantId: VARIANTS.airTag,
//         quantity: 1,
//         preferredForm: form
//       });
//     } else {
//       removeItemGroup(form, 'airtapouch');
//     }
//   }
//   // ===============================================================
//   // BUNGEE COLOR
//   // ===============================================================
//   function getSelectedHarnessColor() {
//     const selected = document.querySelector('[variant-option-name="Color"] label.option-item-active input');
//     return selected ? selected.value.trim().toLowerCase() : '';
//   }

//   function getVariantByColor(variants, color) {
//     return (variants.find(v => String(v.color).trim().toLowerCase() === color) || null);
//   }

//   function updateBundleProducts(premiumBungeeVariants, preferredForm = null) {
//     if (!Array.isArray(premiumBungeeVariants)) {
//       return;
//     }
//     const color = getSelectedHarnessColor();
//     if (!color) {
//       return;
//     }
//     const bungee = getVariantByColor(premiumBungeeVariants, color);
//     if (!bungee) {
//       return;
//     }
//     const leashRadio = document.querySelector('.addon-items-wrapper input[name="properties[leash-style]"]:checked');
//     if (leashRadio && leashRadio.value === 'Bungee') {
//       upsertAddonItem({
//         key: 'leashstyle',
//         variantId: bungee.id,
//         quantity: 1,
//         preferredForm: preferredForm
//       });
//     }
//     const bungeeImg = document.querySelector('.leash-style-wrapper img');
//     if (bungeeImg) {
//       bungeeImg.src = bungee.image || '';
//       bungeeImg.srcset = '';
//       bungeeImg.alt = bungee.title || '';
//     }
//   }
//   // ===============================================================
//   // FINAL MAIN PROPERTY SYNC  (first line of defense — runs on
//   // click/submit, before GemPages reads the form)
//   // ===============================================================
//   function syncMainPropertiesBeforeAdd(trigger, preferredForm = null) {
//     const form = getForm(preferredForm);
//     if (!form) {
//       return false;
//     }
//     const groupId = ensureAddonGroupId(`final sync before ${trigger}`, form);
//     if (!groupId) {
//       return false;
//     }
//     syncChildGroupIds(form, groupId);
//     // -------------------------------------------------------------
//     // DOG NAME
//     // -------------------------------------------------------------
//     const dogInput = document.querySelector('input[name="properties[dog-name]"]');
//     let dogValue = dogInput ? dogInput.value.trim() : '';
//     if (!dogValue) {
//       dogValue = trackedValues.dogname;
//     }
//     if (dogValue) {
//       setMainProductProperty('dog-name', dogValue, `FINAL SYNC — ${trigger}`, form);
//       trackedValues.dogname = dogValue;
//     }
//     // -------------------------------------------------------------
//     // PHONE
//     // -------------------------------------------------------------
//     const phoneInput = document.querySelector('input[name="properties[phone-number]"]');
//     let phoneValue = phoneInput ? phoneInput.value.trim() : '';
//     if (!phoneValue) {
//       phoneValue = trackedValues.phone;
//     }
//     if (phoneValue) {
//       setMainProductProperty('phone-number', phoneValue, `FINAL SYNC — ${trigger}`, form);
//       trackedValues.phone = phoneValue;
//     }
//     // -------------------------------------------------------------
//     // LEASH
//     // -------------------------------------------------------------
//     const checkedLeash = document.querySelector('.addon-items-wrapper input[name="properties[leash-style]"]:checked');
//     let leashValue = checkedLeash ? checkedLeash.value.trim() : '';
//     if (!leashValue) {
//       leashValue = trackedValues.leashstyle;
//     }
//     if (checkedLeash) {
//       processLeashStyle(checkedLeash, form);
//     } else if (leashValue) {
//       setMainProductProperty('leash-style', leashValue, `FINAL SYNC — ${trigger}`, form);
//       const leashVariant = leashValue === 'Bungee' ? VARIANTS.leashBungee : VARIANTS.leashRegular;
//       upsertAddonItem({
//         key: 'leashstyle',
//         variantId: leashVariant,
//         quantity: 1,
//         preferredForm: form
//       });
//     }
//     syncChildGroupIds(form, groupId);
//     const requiredProperties = ['_addon_group_id', 'leash-style'];
//     const missing = requiredProperties.filter(propertyName => {
//       const input = document.querySelector(`input[name="properties[${propertyName}]"]`);
//       return !input || !input.value.trim();
//     });
//     return missing.length === 0;
//   }
//   // ===============================================================
//   // NETWORK-LEVEL GUARANTEE
//   // ===============================================================
//   //
//   // Regardless of exactly how/when GemPages reads the DOM to build its
//   // Add to Cart request, every code path must eventually call
//   // fetch()/XMLHttpRequest against /cart/add or /cart/add.js — that is
//   // the only endpoint Shopify exposes for this. Intercepting THAT call
//   // guarantees the main item carries the tracked properties + group id,
//   // and that every child addon item shares the same group id, no matter
//   // what internal timing GemPages uses.
//   //
//   // Scoped defensively: only requests whose "main" item variant id
//   // matches the CURRENT value of this form's `id` input are touched, so
//   // unrelated Add to Cart calls elsewhere on the page (upsells, gifts,
//   // cross-sells) are never modified. Any parsing failure falls back to
//   // sending the original, unmodified request.
//   // ===============================================================
//   function isCartAddUrl(url) {
//     try {
//       const pathname = new URL(url, window.location.href).pathname;
//       return pathname === '/cart/add' || pathname === '/cart/add.js';
//     } catch (error) {
//       return false;
//     }
//   }

//   function getCurrentMainVariantId() {
//     const form = getForm();
//     const idInput = form && form.querySelector('input[name="id"]');
//     return idInput ? String(idInput.value) : null;
//   }

//   function buildGuaranteedProperties(existingProperties, groupId) {
//     const properties = Object.assign({}, existingProperties || {});
//     if (trackedValues.dogname) {
//       properties['dog-name'] = trackedValues.dogname;
//     }
//     if (trackedValues.phone) {
//       properties['phone-number'] = trackedValues.phone;
//     }
//     if (trackedValues.leashstyle) {
//       properties['leash-style'] = trackedValues.leashstyle;
//     }
//     if (groupId) {
//       properties['_addon_group_id'] = groupId;
//     }
//     return properties;
//   }

//   function patchJsonBody(parsed, groupId, mainVariantId) {
//     if (Array.isArray(parsed.items)) {
//       parsed.items.forEach(item => {
//         if (!item || typeof item !== 'object') {
//           return;
//         }
//         const isChildAddon = !!(item.properties && item.properties._addon_type);
//         if (isChildAddon) {
//           item.properties = Object.assign({}, item.properties, {
//             _addon_group_id: groupId || item.properties._addon_group_id
//           });
//         } else if (String(item.id) === mainVariantId) {
//           item.properties = buildGuaranteedProperties(item.properties, groupId);
//         }
//       });
//       return parsed;
//     }
//     if (String(parsed.id) === mainVariantId) {
//       const isChildAddon = !!(parsed.properties && parsed.properties._addon_type);
//       if (isChildAddon) {
//         parsed.properties = Object.assign({}, parsed.properties, {
//           _addon_group_id: groupId || parsed.properties._addon_group_id
//         });
//       } else {
//         parsed.properties = buildGuaranteedProperties(parsed.properties, groupId);
//       }
//     }
//     return parsed;
//   }

//   function patchFormData(formData, groupId, mainVariantId) {
//     const itemIndexes = new Set();
//     for (const key of formData.keys()) {
//       const match = key.match(/^items\[(\d+)\]/);
//       if (match) {
//         itemIndexes.add(match[1]);
//       }
//     }
//     if (itemIndexes.size === 0) {
//       // Flat, single-product form (id / quantity / properties at the root).
//       if (formData.get('id') !== mainVariantId) {
//         return formData;
//       }
//       if (formData.has('properties[_addon_type]')) {
//         if (groupId) {
//           formData.set('properties[_addon_group_id]', groupId);
//         }
//         return formData;
//       }
//       if (trackedValues.dogname) {
//         formData.set('properties[dog-name]', trackedValues.dogname);
//       }
//       if (trackedValues.phone) {
//         formData.set('properties[phone-number]', trackedValues.phone);
//       }
//       if (trackedValues.leashstyle) {
//         formData.set('properties[leash-style]', trackedValues.leashstyle);
//       }
//       if (groupId) {
//         formData.set('properties[_addon_group_id]', groupId);
//       }
//       return formData;
//     }
//     itemIndexes.forEach(index => {
//       const idKey = `items[${index}][id]`;
//       const addonTypeKey = `items[${index}][properties][_addon_type]`;
//       const groupIdKey = `items[${index}][properties][_addon_group_id]`;
//       const isChildAddon = formData.has(addonTypeKey);
//       if (isChildAddon) {
//         if (groupId) {
//           formData.set(groupIdKey, groupId);
//         }
//         return;
//       }
//       if (formData.get(idKey) !== mainVariantId) {
//         return;
//       }
//       if (trackedValues.dogname) {
//         formData.set(`items[${index}][properties][dog-name]`, trackedValues.dogname);
//       }
//       if (trackedValues.phone) {
//         formData.set(`items[${index}][properties][phone-number]`, trackedValues.phone);
//       }
//       if (trackedValues.leashstyle) {
//         formData.set(`items[${index}][properties][leash-style]`, trackedValues.leashstyle);
//       }
//       if (groupId) {
//         formData.set(groupIdKey, groupId);
//       }
//     });
//     return formData;
//   }

//   function patchRequestBody(body, groupId, mainVariantId) {
//     if (body == null || !mainVariantId) {
//       return body;
//     }
//     if (body instanceof FormData) {
//       return patchFormData(body, groupId, mainVariantId);
//     }
//     if (typeof body === 'string') {
//       try {
//         const parsed = JSON.parse(body);
//         return JSON.stringify(patchJsonBody(parsed, groupId, mainVariantId));
//       } catch (jsonError) {
//         try {
//           const params = new URLSearchParams(body);
//           const asFormData = new FormData();
//           for (const [key, value] of params.entries()) {
//             asFormData.append(key, value);
//           }
//           patchFormData(asFormData, groupId, mainVariantId);
//           const rebuilt = new URLSearchParams();
//           for (const [key, value] of asFormData.entries()) {
//             rebuilt.append(key, value);
//           }
//           return rebuilt.toString();
//         } catch (urlError) {
//           return body;
//         }
//       }
//     }
//     return body;
//   }

//   function installCartAddNetworkGuarantee() {
//     if (window.__pawlyCartAddPatchInstalled) {
//       return;
//     }
//     window.__pawlyCartAddPatchInstalled = true;
//     const originalFetch = window.fetch;
//     if (typeof originalFetch === 'function') {
//       window.fetch = async function(input, init) {
//         try {
//           const isRequestObj = typeof Request !== 'undefined' && input instanceof Request;
//           const url = isRequestObj ? input.url : typeof input === 'string' ? input : (input && input.url) || '';
//           if (isCartAddUrl(url)) {
//             const mainVariantId = getCurrentMainVariantId();
//             if (mainVariantId) {
//               const groupId = ensureAddonGroupId('network fetch guarantee');
//               if (isRequestObj) {
//                 const originalBody = await input.clone().text();
//                 const patchedBody = patchRequestBody(originalBody, groupId, mainVariantId);
//                 input = new Request(input, {
//                   body: patchedBody
//                 });
//               } else if (init && init.body) {
//                 init = Object.assign({}, init, {
//                   body: patchRequestBody(init.body, groupId, mainVariantId)
//                 });
//               }
//             }
//           }
//         } catch (patchError) {
//           // Never block the real request if patching fails.
//         }
//         return originalFetch.call(this, input, init);
//       };
//     }
//     const OriginalXHR = window.XMLHttpRequest;
//     if (OriginalXHR) {
//       const originalOpen = OriginalXHR.prototype.open;
//       const originalSend = OriginalXHR.prototype.send;
//       OriginalXHR.prototype.open = function(method, url) {
//         this.__pawlyCartAddUrl = url;
//         return originalOpen.apply(this, arguments);
//       };
//       OriginalXHR.prototype.send = function(body) {
//         try {
//           if (isCartAddUrl(this.__pawlyCartAddUrl || '')) {
//             const mainVariantId = getCurrentMainVariantId();
//             if (mainVariantId && body) {
//               const groupId = ensureAddonGroupId('network xhr guarantee');
//               body = patchRequestBody(body, groupId, mainVariantId);
//             }
//           }
//         } catch (patchError) {
//           // Never block the real request if patching fails.
//         }
//         return originalSend.call(this, body);
//       };
//     }
//   }
//   // ===============================================================
//   // NATIVE `form.submit()` GUARANTEE
//   // ===============================================================
//   // A raw `form.submit()` call does NOT dispatch a `submit` event, so
//   // the capture-phase listener below would never run for it. Patch it
//   // (scoped to only our own form) so the sync still runs first.
//   // ===============================================================
//   function installDirectFormSubmitGuarantee() {
//     if (window.__pawlyFormSubmitPatchInstalled) {
//       return;
//     }
//     window.__pawlyFormSubmitPatchInstalled = true;
//     const originalSubmit = HTMLFormElement.prototype.submit;
//     HTMLFormElement.prototype.submit = function() {
//       if (this.matches && this.matches(FORM_SELECTOR)) {
//         ensureLeashInitialized(this);
//         syncMainPropertiesBeforeAdd('DIRECT FORM.SUBMIT()', this);
//       }
//       return originalSubmit.apply(this, arguments);
//     };
//   }
//   // ===============================================================
//   // DOG NAME INPUT
//   // ===============================================================
//   document.addEventListener('input', function(e) {
//     if (!e.target.matches('input[name="properties[dog-name]"]')) {
//       return;
//     }
//     const form = e.target.closest('form') || getForm();
//     processDogName(e.target, form);
//   });
//   // ===============================================================
//   // PHONE INPUT
//   // ===============================================================
//   document.addEventListener('input', function(e) {
//     if (!e.target.matches('input[name="properties[phone-number]"]')) {
//       return;
//     }
//     const form = e.target.closest('form') || getForm();
//     processPhone(e.target, form);
//   });
//   // ===============================================================
//   // LEASH CHANGE
//   // ===============================================================
//   document.addEventListener('change', function(e) {
//     if (!e.target.matches('.addon-items-wrapper input[name="properties[leash-style]"]')) {
//       return;
//     }
//     const form = e.target.closest('form') || getForm();
//     processLeashStyle(e.target, form);
//   });
//   // ===============================================================
//   // SIZE CHANGE
//   // ===============================================================
//   document.addEventListener('change', function(e) {
//     if (!e.target.matches('[variant-option-name="Size"] input')) {
//       return;
//     }
//     const dogInput = document.querySelector('input[name="properties[dog-name]"]');
//     if (dogInput && dogInput.value.trim()) {
//       const form = dogInput.closest('form') || getForm();
//       processDogName(dogInput, form);
//     }
//     ensureLeashInitialized();
//   });
//   // ===============================================================
//   // AIRTAG
//   // ===============================================================
//   document.addEventListener('change', function(e) {
//     if (!e.target.matches('#airtag-addon-toggle')) {
//       return;
//     }
//     const form = e.target.closest('form') || getForm();
//     handleAirTagChange(e.target, form);
//   });
//   // ===============================================================
//   // ADD TO CART CLICK — CAPTURE PHASE (first line of defense)
//   // ===============================================================
//   document.addEventListener('click', function(e) {
//     const button = e.target.closest('button[type="submit"], input[type="submit"], [data-gp-add-to-cart], .add-to-cart');
//     if (!button) {
//       return;
//     }
//     let form = button.closest('form');
//     if (!form || !form.matches(FORM_SELECTOR)) {
//       form = getForm();
//     }
//     if (!form) {
//       return;
//     }
//     if (!form.closest('.custom-product-wrapper') && !form.matches(FORM_SELECTOR)) {
//       return;
//     }
//     ensureLeashInitialized(form);
//     syncMainPropertiesBeforeAdd('ADD TO CART CLICK', form);
//   }, true);
//   // ===============================================================
//   // FORM SUBMIT — CAPTURE PHASE (first line of defense)
//   // ===============================================================
//   document.addEventListener('submit', function(e) {
//     const form = e.target;
//     if (!form || !form.matches(FORM_SELECTOR)) {
//       return;
//     }
//     ensureLeashInitialized(form);
//     syncMainPropertiesBeforeAdd('FORM SUBMIT', form);
//   }, true);
//   // ===============================================================
//   // INITIALIZE
//   // ===============================================================
//   function initialize() {
//     const form = getForm();
//     if (form) {
//       ensureAddonGroupId('initialization', form);
//     }
//     ensureLeashInitialized(form);
//     installCartAddNetworkGuarantee();
//     installDirectFormSubmitGuarantee();
//     const dogInput = document.querySelector('input[name="properties[dog-name]"]');
//     if (dogInput && dogInput.value.trim()) {
//       processDogName(dogInput, dogInput.closest('form') || getForm());
//     }
//     const phoneInput = document.querySelector('input[name="properties[phone-number]"]');
//     if (phoneInput && phoneInput.value.trim()) {
//       processPhone(phoneInput, phoneInput.closest('form') || getForm());
//     }
//     const bungeeDataEl = document.getElementById('premium-bungee-data');
//     let premiumBungeeVariants = [];
//     if (bungeeDataEl) {
//       try {
//         premiumBungeeVariants = JSON.parse(bungeeDataEl.textContent);
//       } catch (error) {
//         // Ignore malformed bungee data; color-matching simply won't run.
//       }
//     }

//     function runBungeeUpdate() {
//       updateBundleProducts(premiumBungeeVariants, getForm());
//     }
//     window.addEventListener('load', function() {
//       setTimeout(runBungeeUpdate, 500);
//     });
//     document.addEventListener('change', function(e) {
//       if (e.target.matches('[variant-option-name="Color"] input')) {
//         setTimeout(runBungeeUpdate, 0);
//       }
//     });
//     // ---------------------------------------------------------------
//     // MUTATION OBSERVER — recovers tracked state after GemPages
//     // re-renders the form (still useful for UX/child items; no longer
//     // the correctness guarantee for the network request itself).
//     // ---------------------------------------------------------------
//     let observerTimer = null;
//     const wrapperObserver = new MutationObserver(function() {
//       clearTimeout(observerTimer);
//       observerTimer = setTimeout(function() {
//         const form = getForm();
//         if (!form) {
//           return;
//         }
//         activeForm = form;
//         ensureAddonGroupId('GemPages form re-render', form);
//         ensureLeashInitialized(form);
//         if (trackedValues.dogname) {
//           setMainProductProperty('dog-name', trackedValues.dogname, 'form re-render recovery', form);
//         }
//         if (trackedValues.phone) {
//           setMainProductProperty('phone-number', trackedValues.phone, 'form re-render recovery', form);
//         }
//         if (trackedValues.leashstyle) {
//           setMainProductProperty('leash-style', trackedValues.leashstyle, 'form re-render recovery', form);
//           const leashVariant = trackedValues.leashstyle === 'Bungee' ? VARIANTS.leashBungee : VARIANTS.leashRegular;
//           upsertAddonItem({
//             key: 'leashstyle',
//             variantId: leashVariant,
//             quantity: 1,
//             preferredForm: form
//           });
//         }
//         const groupInput = form.querySelector('input[name="properties[_addon_group_id]"]');
//         if (groupInput && groupInput.value) {
//           syncChildGroupIds(form, groupInput.value);
//         }
//       }, 100);
//     });
//     wrapperObserver.observe(document.body, {
//       childList: true,
//       subtree: true
//     });
//   }
//   // ===============================================================
//   // BOOT — only run when the required addon form actually exists.
//   // ===============================================================
//   //
//   // Keeps this engine from ever registering anything meaningful on
//   // product pages (or any other page) that don't have this exact
//   // custom addon form, while still working if this specific form is
//   // rendered a little after initial parse.
//   // ===============================================================
//   function boot() {
//     if (document.querySelector(FORM_SELECTOR)) {
//       initialize();
//       return true;
//     }
//     return false;
//   }
//   if (!boot()) {
//     const bootObserver = new MutationObserver(function() {
//       if (boot()) {
//         bootObserver.disconnect();
//       }
//     });
//     bootObserver.observe(document.documentElement, {
//       childList: true,
//       subtree: true
//     });
//   }
// })();
// ===============================================================
// SLIDER FIX (kept global/independent of the addon form — this
// applies to any GemPages image slider on any page, addon or not)
// ===============================================================
window.addEventListener('load', function() {
  let executed = false;

  function tryForceFirstImage() {
    if (executed) {
      return;
    }
    const activeSlide = document.querySelector('.gem-slider-item.swiper-slide-active');
    const firstSlide = document.querySelector('.gem-slider-item[data-swiper-slide-index="0"]');
    const wrapper = document.querySelector('.gem-slider-wrapper');
    if (!activeSlide || !firstSlide || !wrapper) {
      return;
    }
    document.querySelectorAll('.gem-slider-item').forEach(slide => {
      slide.classList.remove('swiper-slide-active', 'slide-visible', 'slide-fully-visible');
    });
    firstSlide.classList.add('swiper-slide-active', 'slide-visible', 'slide-fully-visible');
    wrapper.style.transform = 'translate3d(0px, 0px, 0px)';
    executed = true;
    observer.disconnect();
  }
  const observer = new MutationObserver(function() {
    tryForceFirstImage();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  tryForceFirstImage();
});

(function() {
  if (window.__addonCartSyncInitialized) {
    return;
  }
  window.__addonCartSyncInitialized = true;
  // ===============================================================
  // CONFIG
  // ===============================================================
  let isUpdating = false;
  let observer = null;
  let latestCart = null;
  const loggedActions = new Set();
  const handledRemoveElements = new WeakSet();
  // ===============================================================
  // OPTIMISTIC HIDDEN PROPERTIES
  // ===============================================================
  const optimisticHiddenProperties = new Set();

  // ===============================================================
  // DEBUG LOGGER
  // ===============================================================
  function logOnce(key, label, ...data) {
    if (loggedActions.has(key)) {
      return;
    }
    loggedActions.add(key);
    // console.log(`%c[Addon Cart Sync] ${new Date().toISOString()} — ${label}`, 'color:#08f;font-weight:bold', ...data);
  }

  function cleanupLogMemory() {
    if (loggedActions.size > 500) {
      loggedActions.clear();
    }
  }
  // ===============================================================
  // NORMALIZE NAME
  // ===============================================================
  function normalizeName(value) {
    if (!value) {
      return '';
    }
    return String(value).toLowerCase().replace(/[\s_\-]+/g, '');
  }
  // ===============================================================
  // DYNAMIC PROPERTY MATCHING
  // ===============================================================
  //
  // Example:
  //
  // dog-name      -> dogname
  // dogname       -> dogname
  //
  // phone-number  -> phonenumber
  // phone         -> phone
  //
  // leash-style   -> leashstyle
  // leashstyle    -> leashstyle
  //
  // ===============================================================
  function propertyMatchesAddonType(propertyName, addonType) {
    const propertyNormalized = normalizeName(propertyName);
    const addonNormalized = normalizeName(addonType);
    if (!propertyNormalized || !addonNormalized) {
      return false;
    }
    if (propertyNormalized === addonNormalized) {
      return true;
    }
    if (propertyNormalized.startsWith(addonNormalized)) {
      return true;
    }
    if (addonNormalized.startsWith(propertyNormalized)) {
      return true;
    }
    return false;
  }
  // ===============================================================
  // GET CUSTOM PROPERTIES
  // ===============================================================
  function getCustomPropertyNames(item) {
    if (!item || !item.properties) {
      return [];
    }
    return Object.keys(item.properties).filter(function(propertyName) {
      // Ignore internal addon properties.
      return (propertyName !== '_addon_group_id' && propertyName !== '_addon_type' && !propertyName.startsWith('_'));
    });
  }
  // ===============================================================
  // FIND PROPERTY FOR ADDON TYPE
  // ===============================================================
  function findPropertyForAddonType(mainItem, addonType) {
    if (!mainItem || !addonType) {
      return null;
    }
    const propertyNames = getCustomPropertyNames(mainItem);
    if (!propertyNames.length) {
      return null;
    }
    // -------------------------------------------------------------
    // FIRST: EXACT NORMALIZED MATCH
    // -------------------------------------------------------------
    const exactMatch = propertyNames.find(function(propertyName) {
      return (normalizeName(propertyName) === normalizeName(addonType));
    });
    if (exactMatch) {
      return exactMatch;
    }
    // -------------------------------------------------------------
    // SECOND: PREFIX / PARTIAL MATCH
    // -------------------------------------------------------------
    const partialMatch = propertyNames.find(function(propertyName) {
      return propertyMatchesAddonType(propertyName, addonType);
    });
    return partialMatch || null;
  }
  // ===============================================================
  // GET CART
  // ===============================================================
  async function getCart(forceFresh = true) {
    const response = await fetch('/cart.js', {
      credentials: 'same-origin',
      cache: forceFresh ? 'no-store' : 'default'
    });
    if (!response.ok) {
      throw new Error('Unable to load cart');
    }
    const cart = await response.json();
    latestCart = cart;
    return cart;
  }
  // ===============================================================
  // UPDATE LINE ITEM
  // ===============================================================
  async function updateLineItem(itemKey, quantity, properties) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: quantity,
        properties: properties
      })
    });
    if (!response.ok) {
      throw new Error('Unable to update cart item');
    }
    const cart = await response.json();
    latestCart = cart;
    return cart;
  }
  // ===============================================================
  // RELATION HELPERS
  // ===============================================================
  function getAddonTypesForGroup(cart, groupId) {
    const types = new Set();
    if (!cart || !Array.isArray(cart.items)) {
      return types;
    }
    cart.items.forEach(function(item) {
      const props = item.properties || {};
      if (props._addon_group_id === groupId && props._addon_type) {
        types.add(props._addon_type);
      }
    });
    return types;
  }

  function findMainItemByGroupId(cart, groupId) {
    if (!cart || !Array.isArray(cart.items)) {
      return null;
    }
    return (cart.items.find(function(item) {
      const props = item.properties || {};
      return (props._addon_group_id === groupId && !props._addon_type);
    }) || null);
  }

  function findChildItemByGroupId(cart, groupId, addonType) {
    if (!cart || !Array.isArray(cart.items)) {
      return null;
    }
    return (cart.items.find(function(item) {
      const props = item.properties || {};
      return (props._addon_group_id === groupId && props._addon_type === addonType);
    }) || null);
  }
  // ===============================================================
  // GET PROPERTIES TO REMOVE
  // ===============================================================
  function getPropertiesToRemove(item, availableAddonTypes) {
    const currentProperties = item.properties || {};
    const updatedProperties = {
      ...currentProperties
    };
    let changed = false;
    const customProperties = getCustomPropertyNames(item);
    customProperties.forEach(function(propertyName) {
      const matchingAddon = Array.from(availableAddonTypes).find(function(addonType) {
        return propertyMatchesAddonType(propertyName, addonType);
      });
      // No matching child addon exists.
      if (!matchingAddon) {
        delete updatedProperties[propertyName];
        changed = true;
      }
    });
    return {
      changed,
      properties: updatedProperties
    };
  }
  // ===============================================================
  // HIDE DRAWER PROPERTY
  // ===============================================================
  function hideDrawerPropertyImmediately(groupId, propertyName) {
    if (!groupId || !propertyName) {
      return;
    }
    optimisticHiddenProperties.add(`${groupId}::${propertyName}`);
    const drawerItems = document.querySelectorAll('.cart-drawer-item[data-addon-group-id]');
    drawerItems.forEach(function(item) {
      const itemGroupId = item.dataset.addonGroupId;
      const addonType = item.dataset.addonType;
      if (itemGroupId !== groupId || addonType) {
        return;
      }
      const propertyElement = item.querySelector(`[data-cart-property="${propertyName}"]`);
      if (propertyElement) {
        propertyElement.style.display = 'none';
      }
    });
  }
  // ===============================================================
  // REMOVE MAIN PROPERTY
  // ===============================================================
  async function removeMainPropertyImmediately(groupId, addonType, trigger) {
    if (!groupId || !addonType) {
      return;
    }
    // ---------------------------------------------------------------
    // VERIFY BEFORE ACTING — always re-check against a FRESH cart
    // fetch (never the cached/possibly-stale `latestCart`) that this
    // addon type is actually gone before touching the main product.
    //
    // The click that gets here is only a heuristic guess that a
    // "remove" button was clicked; it can also fire for other controls
    // inside the same cart line item (e.g. a quantity decrease that
    // does not remove the item). Removing the main property in that
    // case would violate "do not remove unrelated/still-present
    // properties", so we only proceed once the child addon is
    // confirmed absent from real Shopify cart data.
    // ---------------------------------------------------------------
    let cart;
    try {
      cart = await getCart(true);
    } catch (error) {
      console.error('[Addon Cart Sync] Unable to get fresh cart for verification', error);
      return;
    }
    if (getAddonTypesForGroup(cart, groupId).has(addonType)) {
      // Child addon is still present (e.g. quantity was only lowered,
      // not removed) — leave the main product untouched.
      return;
    }
    // -------------------------------------------------------------
    // FIND CHILD
    // -------------------------------------------------------------
    const childItem = findChildItemByGroupId(cart, groupId, addonType);
    // -------------------------------------------------------------
    // FIND MAIN
    // -------------------------------------------------------------
    let mainItem = findMainItemByGroupId(cart, groupId);
    if (!mainItem) {
      logOnce(`${groupId}::${addonType}::NO_MAIN`, 'MAIN PRODUCT NOT FOUND', {
        relationId: groupId,
        addonType,
        trigger
      });
      return;
    }
    // -------------------------------------------------------------
    // DYNAMICALLY FIND PROPERTY
    // -------------------------------------------------------------
    const propertyName = findPropertyForAddonType(mainItem, addonType);
    if (!propertyName) {
      logOnce(`${groupId}::${addonType}::NO_PROPERTY`, 'NO MATCHING MAIN PROPERTY FOUND', {
        relationId: groupId,
        addonType,
        mainProduct: mainItem.title,
        availableProperties: getCustomPropertyNames(mainItem),
        trigger
      });
      return;
    }
    // -------------------------------------------------------------
    // HIDE PROPERTY IMMEDIATELY
    // -------------------------------------------------------------
    hideDrawerPropertyImmediately(groupId, propertyName);
    const mainProperties = mainItem.properties || {};
    // -------------------------------------------------------------
    // PROPERTY ALREADY REMOVED
    // -------------------------------------------------------------
    if (!Object.prototype.hasOwnProperty.call(mainProperties, propertyName)) {
      logOnce(`${groupId}::${addonType}::${propertyName}::ALREADY_REMOVED`, 'MAIN PROPERTY ALREADY REMOVED', {
        relationId: groupId,
        mainProduct: mainItem.title,
        addonType,
        propertyRemoved: propertyName
      });
      return;
    }
    // -------------------------------------------------------------
    // REMOVE PROPERTY
    // -------------------------------------------------------------
    const updatedProperties = {
      ...mainProperties
    };
    delete updatedProperties[propertyName];
    // -------------------------------------------------------------
    // SINGLE RELATION LOG
    // -------------------------------------------------------------
    logOnce(`${groupId}::${addonType}::${propertyName}`, '🔗 CHILD REMOVED → MAIN PROPERTY REMOVAL', {
      relationId: groupId,
      child: {
        title: childItem ? childItem.title : 'Child addon',
        addonType,
        key: childItem ? childItem.key : null
      },
      main: {
        title: mainItem.title,
        key: mainItem.key
      },
      propertyRemoved: propertyName,
      trigger
    });
    // -------------------------------------------------------------
    // UPDATE MAIN
    // -------------------------------------------------------------
    try {
      await updateLineItem(mainItem.key, mainItem.quantity, updatedProperties);
      logOnce(`${groupId}::${addonType}::${propertyName}::SUCCESS`, '✅ MAIN PROPERTY REMOVED', {
        relationId: groupId,
        mainProduct: mainItem.title,
        propertyRemoved: propertyName
      });
      updateDrawerDisplay();
    } catch (error) {
      console.error('[Addon Cart Sync] Main property update failed', error);
      // -----------------------------------------------------------
      // RETRY
      // -----------------------------------------------------------
      try {
        const freshCart = await getCart(true);
        const freshMain = findMainItemByGroupId(freshCart, groupId);
        if (!freshMain) {
          return;
        }
        const freshProperty = findPropertyForAddonType(freshMain, addonType);
        if (!freshProperty) {
          return;
        }
        const freshProperties = {
          ...(freshMain.properties || {})
        };
        delete freshProperties[freshProperty];
        await updateLineItem(freshMain.key, freshMain.quantity, freshProperties);
        logOnce(`${groupId}::${addonType}::${freshProperty}::RETRY_SUCCESS`, '✅ MAIN PROPERTY REMOVED ON RETRY', {
          relationId: groupId,
          mainProduct: freshMain.title,
          propertyRemoved: freshProperty
        });
        updateDrawerDisplay();
      } catch (retryError) {
        console.error('[Addon Cart Sync] Retry failed', retryError);
      }
    }
    cleanupLogMemory();
  }
  // ===============================================================
  // FULL CART SYNC
  // ===============================================================
  async function syncRemovedAddonProperties() {
    if (isUpdating) {
      return;
    }
    isUpdating = true;
    try {
      const cart = await getCart(true);
      if (!cart || !Array.isArray(cart.items)) {
        return;
      }
      for (const item of cart.items) {
        const props = item.properties || {};
        const groupId = props._addon_group_id;
        const addonType = props._addon_type;
        // Only main products.
        if (!groupId) {
          continue;
        }
        if (addonType) {
          continue;
        }
        const availableAddons = getAddonTypesForGroup(cart, groupId);
        const result = getPropertiesToRemove(item, availableAddons);
        if (!result.changed) {
          continue;
        }
        // ---------------------------------------------------------
        // FIND WHICH PROPERTIES WILL BE REMOVED
        // ---------------------------------------------------------
        const currentProperties = item.properties || {};
        const removedProperties = Object.keys(currentProperties).filter(function(propertyName) {
          return (!Object.prototype.hasOwnProperty.call(result.properties, propertyName) && !propertyName.startsWith('_'));
        });
        removedProperties.forEach(function(propertyName) {
          optimisticHiddenProperties.add(`${groupId}::${propertyName}`);
          logOnce(`SYNC::${groupId}::${propertyName}`, '🔄 STALE MAIN PROPERTY CLEANUP', {
            relationId: groupId,
            mainProduct: item.title,
            propertyRemoved: propertyName
          });
        });
        // ---------------------------------------------------------
        // UPDATE MAIN
        // ---------------------------------------------------------
        try {
          await updateLineItem(item.key, item.quantity, result.properties);
        } catch (updateError) {
          console.error('[Addon Cart Sync] Main property cleanup failed', {
            mainProduct: item.title,
            relationId: groupId,
            error: updateError
          });
        }
      }
    } catch (error) {
      console.error('[Addon Cart Sync] Cart sync error', error);
    } finally {
      isUpdating = false;
    }
  }
  // ===============================================================
  // DRAWER DISPLAY
  // ===============================================================
  function updateDrawerDisplay() {
    const drawerItems = document.querySelectorAll('.cart-drawer-item[data-addon-group-id]');
    if (!drawerItems.length) {
      return;
    }
    const addonMap = {};
    // -------------------------------------------------------------
    // BUILD ADDON MAP
    // -------------------------------------------------------------
    drawerItems.forEach(function(item) {
      const groupId = item.dataset.addonGroupId;
      const addonType = item.dataset.addonType;
      if (!groupId) {
        return;
      }
      if (!addonMap[groupId]) {
        addonMap[groupId] = new Set();
      }
      if (addonType) {
        addonMap[groupId].add(addonType);
      }
    });
    // -------------------------------------------------------------
    // MAIN PRODUCTS
    // -------------------------------------------------------------
    drawerItems.forEach(function(item) {
      const groupId = item.dataset.addonGroupId;
      const addonType = item.dataset.addonType;
      // Skip child items.
      if (!groupId || addonType) {
        return;
      }
      const availableAddons = addonMap[groupId] || new Set();
      // ---------------------------------------------------------
      // FIND ALL PROPERTY ELEMENTS
      // ---------------------------------------------------------
      const propertyElements = item.querySelectorAll('[data-cart-property]');
      propertyElements.forEach(function(propertyElement) {
        const propertyName = propertyElement.dataset.cartProperty;
        if (!propertyName) {
          return;
        }
        // Ignore internal properties.
        if (propertyName.startsWith('_')) {
          return;
        }
        // -----------------------------------------------------
        // FIND MATCHING CHILD ADDON
        // -----------------------------------------------------
        const hasMatchingAddon = Array.from(availableAddons).some(function(addonType) {
          return propertyMatchesAddonType(propertyName, addonType);
        });
        const optimisticKey = `${groupId}::${propertyName}`;
        // -----------------------------------------------------
        // OPTIMISTIC STATE
        // -----------------------------------------------------
        if (optimisticHiddenProperties.has(optimisticKey)) {
          if (hasMatchingAddon) {
            optimisticHiddenProperties.delete(optimisticKey);
            propertyElement.style.display = '';
          } else {
            propertyElement.style.display = 'none';
          }
          return;
        }
        // -----------------------------------------------------
        // NORMAL STATE
        // -----------------------------------------------------
        propertyElement.style.display = hasMatchingAddon ? '' : 'none';
      });
    });
  }
  // ===============================================================
  // RUN SYNC
  // ===============================================================
  async function runAddonSync() {
    await syncRemovedAddonProperties();
    updateDrawerDisplay();
  }
  // ===============================================================
  // DEBOUNCE
  // ===============================================================
  function debounce(func, delay) {
    let timer;
    return function() {
      clearTimeout(timer);
      timer = setTimeout(function() {
        func();
      }, delay);
    };
  }
  const debouncedRunAddonSync = debounce(runAddonSync, 0);
  // ===============================================================
  // FIND DRAWER ITEM
  // ===============================================================
  function getDrawerItemFromEvent(event) {
    if (!event || !event.target) {
      return null;
    }
    return event.target.closest('.cart-drawer-item[data-addon-group-id]');
  }
  // ===============================================================
  // CHILD REMOVE CLICK
  // ===============================================================
  async function handleChildRemoveClick(drawerItem) {
    if (!drawerItem) {
      return;
    }
    const groupId = drawerItem.dataset.addonGroupId;
    const addonType = drawerItem.dataset.addonType;
    // Only child.
    if (!groupId || !addonType) {
      return;
    }
    const actionKey = `CLICK::${groupId}::${addonType}`;
    logOnce(actionKey, '⚡ CHILD REMOVE CLICK DETECTED', {
      relationId: groupId,
      addonType
    });
    await removeMainPropertyImmediately(groupId, addonType, 'child remove click');
  }
  // ===============================================================
  // INITIALIZE
  // ===============================================================
  function init() {
    // -------------------------------------------------------------
    // INITIAL CART
    // -------------------------------------------------------------
    getCart(true).then(function() {
      updateDrawerDisplay();
    }).catch(function() {});
    // -------------------------------------------------------------
    // INITIAL SYNC
    // -------------------------------------------------------------
    runAddonSync();
    // -------------------------------------------------------------
    // REMOVE CLICK
    // -------------------------------------------------------------
    document.addEventListener('click', function(event) {
      const drawerItem = getDrawerItemFromEvent(event);
      if (!drawerItem) {
        return;
      }
      const addonType = drawerItem.dataset.addonType;
      const groupId = drawerItem.dataset.addonGroupId;
      // Only child.
      if (!groupId || !addonType) {
        return;
      }
      // Prevent duplicate handling.
      if (handledRemoveElements.has(drawerItem)) {
        return;
      }
      // ---------------------------------------------------------
      // FIND REMOVE BUTTON
      // ---------------------------------------------------------
      const removeButton = event.target.closest('button, a, [role="button"]');
      if (!removeButton) {
        return;
      }
      const isQuantityControl = removeButton.closest('quantity-input, .quantity, [name="plus"], [name="minus"]');
      if (isQuantityControl) {
        return;
      }
      const looksLikeRemove = removeButton.matches('[data-cart-remove], [data-line-item-remove], .cart-remove, .cart-item__remove, .remove, .delete') || removeButton.querySelector('svg') || /remove|delete/i.test(removeButton.getAttribute('aria-label') || '') || /remove|delete/i.test(removeButton.textContent || '');
      if (!looksLikeRemove) {
        return;
      }
      handledRemoveElements.add(drawerItem);
      handleChildRemoveClick(drawerItem);
    }, true);
    // -------------------------------------------------------------
    // CART UPDATED
    // -------------------------------------------------------------
    document.addEventListener('cart:updated', function() {
      getCart(true).then(function() {
        updateDrawerDisplay();
        debouncedRunAddonSync();
      }).catch(function() {
        debouncedRunAddonSync();
      });
    });
    // -------------------------------------------------------------
    // CART REFRESH
    // -------------------------------------------------------------
    document.addEventListener('cart:refresh', function() {
      getCart(true).then(function() {
        updateDrawerDisplay();
        debouncedRunAddonSync();
      }).catch(function() {
        debouncedRunAddonSync();
      });
    });
    // -------------------------------------------------------------
    // CART DRAWER OBSERVER
    // -------------------------------------------------------------
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      observer = new MutationObserver(function(mutations) {
        const isLineItemChange = mutations.some(function(mutation) {
          const nodes = [...mutation.addedNodes, ...mutation.removedNodes];
          return nodes.some(function(node) {
            if (node.nodeType !== 1) {
              return false;
            }
            return ((node.matches && node.matches('.cart-drawer-item')) || (node.querySelector && node.querySelector('.cart-drawer-item')));
          });
        });
        if (!isLineItemChange) {
          return;
        }
        updateDrawerDisplay();
        debouncedRunAddonSync();
      });
      observer.observe(cartDrawer, {
        childList: true,
        subtree: true
      });
    }
    // -------------------------------------------------------------
    // CART DRAWER OPEN
    // -------------------------------------------------------------
    document.addEventListener('click', function(event) {
      const cartToggle = event.target.closest('[href="/cart"], [data-cart-toggle], .header__icon--cart');
      if (!cartToggle) {
        return;
      }
      updateDrawerDisplay();
      getCart(true).then(function() {
        updateDrawerDisplay();
      }).catch(function() {});
    });
  }
  // ===============================================================
  // DOM READY
  // ===============================================================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });
  } else {
    init();
  }
})();